
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Capacity Evaluation container

Author: Deimos Space UK

Version: 1.0
*/
import React, { useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
} from "reactstrap";
import TotalSpaceCapacity from "../components/TotalSpaceCapacity";
import SpaceCapacityTime from "../components/SpaceCapacityTime";
import SpaceCapacityClass from "../components/SpaceCapacityClass";
import DeltaSimulations from "../components/DeltaSimulations";
import ObjectDistribution from "../components/ObjectDistribution";
import ComulativeCSI from "../components/ComulativeCSI";
import AllocatedCapacity from "../components/AllocatedCapacity";
import ComulativeIndex from "../components/ComulativeIndex";
export default function CapacityEvaluation() {
  const [loading, setLoading] = useState(false);
  const initialFormData = Object.freeze({
    start: "",
    end: "",
  });
  const [formData, updateFormData] = useState(initialFormData);
  const handleChange = (e) => {
    updateFormData({
      ...formData,
      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };
  const searchByDate = (e) => {
    setLoading(true);
    e.preventDefault();
    //petition to the api
  };
  return (
    <Container>
      <Row className="pt-3">
        <Col sm={6}>
          <h3 style={{color:'#003247'}}>Capacity Evaluation</h3>
        </Col>
        <Col sm={6}>
          <Form>
            <FormGroup>
              <Row>
                <Col>
                  <Label style={{color:'#003247'}}>Start Year</Label>
                  <Input onChange={handleChange} type='date' name="start"></Input>
                </Col>
                <Col>
                  <Label style={{color:'#003247'}}>End Year</Label>
                  <Input type="date" onChange={handleChange} name="end"></Input>
                </Col>
              </Row>
            </FormGroup>
            <Button
              onClick={searchByDate}
              type="submit"
              className="float-right"
              style={{background:'#003247'}}
            >
              Evaluate
            </Button>
          </Form>
        </Col>
      </Row>
      {loading && (
        <>
          <Row>
            <Col xs={4}>
              <TotalSpaceCapacity />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              <SpaceCapacityTime />
            </Col>
            <Col xs={12} lg={6}>
              <SpaceCapacityClass />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              <DeltaSimulations />
            </Col>
            <Col xs={12} lg={6}>
              <ObjectDistribution/>
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={4}>
              <ComulativeCSI/>
            </Col>
            <Col xs={12} lg={4}>
              <AllocatedCapacity/>
            </Col>
            <Col xs={12} lg={4}>
              <ComulativeIndex/>
            </Col>
          </Row>
        </>
      )}
    </Container>
  );
}
